import { render, staticRenderFns } from "./ThirdLogin.vue?vue&type=template&id=30f9e60a&scoped=true"
import script from "./ThirdLogin.vue?vue&type=script&lang=js"
export * from "./ThirdLogin.vue?vue&type=script&lang=js"
import style0 from "./ThirdLogin.vue?vue&type=style&index=0&id=30f9e60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f9e60a",
  null
  
)

export default component.exports